import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Button, Modal, ModalBody } from 'reactstrap'
import { camelizeKeys } from 'humps'
import _ from 'lodash'
import styled from 'styled-components'

import { fetchAnything, startLoading, stopLoading, openError } from 'containers/App/reducers'
import { VEHICLE_NUMBER_LENGTH } from 'constants/Booking'
import CreatableSelect2 from 'components/SelectOptions/CreatableSelect2'

import Header from '../components/Header'
import { updateBooking, fetchSuccess, updateIsAcceptPolicy } from '../reducers'
import { requestGet, requestPatch } from '../api'
import NumericKeypad from '../components/NumericKeypad'
import { Input, EMPTY_OPTION } from '../components/utils'
import PrevStartButton from '../components/PrevStartButton'
import PrevButton from 'components/PrevButton'
import PageNumber from '../components/PageNumber'
import theme from 'vars/theme'
import SelectBase from 'components/SelectOptions/SelectBase'
import ConfirmDriverNameModal from 'components/ConfirmDriverNameModal'
import PolicyModal from 'components/PolicyModal'
import { getStatusCodesAndErrorCode } from 'utils/commonFunctions'
import { isSp } from '../utils'
import StartFromBeginningButton from '../components/StartFromBeginningButton'
import { SpFrame } from '../components/SpFrame'
import SpFooter from '../components/SpFooter'

const VehicleNumberInput = styled.input`
  width: 200px;
  text-align: center;
  font-size: 40px;
  color: #333;
  border-radius: 12px;
`
const VehicleNumberInputSp = styled(VehicleNumberInput)`
  width: 140px;
  font-size: 32px;
`
const RequiredText = styled.span`
  color: ${theme.redPrimary2};
  font-size: 18px;
  margin-right: 16px;
`

const RequiredTextSp = styled.span`
  background-color: ${theme.orangeMedium3};
  color: ${theme.whitePrimary};
  font-size: 10px;
  padding: 1px 8px;
  margin-right: 8px;
  border-radius: 4px;
`

const CreatableSelectWrapper = styled.div`
  width: 260px;
  .mono-creatable__control {
    margin-left: 0;
  }
`
const DRIVER_NAME_ID = 'inputDriverName'

class EntryDriverInfoPage extends Component {
  state = {
    isOpenNumericKeypad: false,
    isOpenModalConfirm: false,
    isOpenPolicyModal: false,
    hasDriverName: false,
    policyData: {},
    isSp: isSp(),
  }

  showConfirmModal = () => this.setState({ isOpenModalConfirm: true })

  closeConfirmModal = () => this.setState({ isOpenModalConfirm: false })

  showPolicyModal = () => this.setState({ isOpenPolicyModal: true })

  closePolicyModal = () => this.setState({ isOpenPolicyModal: false })

  async componentDidMount() {
    const {
      match,
      driver: { driverPhone },
      booking,
      returnEntryPage,
      history,
      vehicleCategories,
      isAcceptPolicyDriverName,
    } = this.props
    const {
      params: { warehouseId, tenantId },
    } = match

    if (returnEntryPage) {
      history.push(`/receipt-booking/${warehouseId}/${tenantId}`)
      return
    }

    this.props.fetchAnything({
      url: '/tablets/list_companies',
      storePath: 'companies',
      data: { tenantId, phoneNumber: driverPhone },
    })

    this.props.startLoading()

    let resp1
    let resp2

    try {
      resp1 = await requestGet('/tablets/get_driver', {
        driverPhone,
      })
      resp2 = await requestGet('/tablets/recent_booking', {
        warehouseId,
        tenantId,
        driverPhone,
      })
    } catch (error) {
      const { errorCodes, status } = getStatusCodesAndErrorCode(error)
      this.props.openError(error.message, true, errorCodes, status)
      return
    } finally {
      this.props.stopLoading()
    }

    const driver = resp1.data ? camelizeKeys(resp1.data.attributes) : {}
    const recentBooking = camelizeKeys(resp2.data)
    this.props.fetchSuccess({ storePath: 'recentBooking', data: recentBooking })
    if (driver.id && driver.name) {
      this.setState({ hasDriverName: true })
    }
    let vehicleCategoryId = booking.vehicleCategory || recentBooking.vehicleCategory || ''
    const filteredVehicleCategories = booking.bookingNo
      ? vehicleCategories
      : vehicleCategories.filter((vc) => vc.displayFlag)
    // 受付カスタマイズで非表示にされている選択肢の場合は空にする
    if (!filteredVehicleCategories.find((vc) => vc.parameterId == vehicleCategoryId)) {
      vehicleCategoryId = ''
    }
    this.props.updateBooking({
      driverCompanyId:
        Number(booking.driverCompanyId || recentBooking.companyId || driver.companyId) || '',
      driverCompanyName:
        booking.driverCompanyName ||
        recentBooking.driverCompanyName ||
        driver.driverCompanyName ||
        '',
      vehicleNumber: booking.vehicleNumber || recentBooking.vehicleNumber || '',
      driverId: Number(driver.id) || '',
      driverName: this.getDriverNameInitPage(isAcceptPolicyDriverName, driver, booking) || '',
      vehicleCategory: vehicleCategoryId,
    })
    window.addEventListener('resize', this.handleResize)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize)
  }
  
  handleResize = () => {
    this.setState({ isSp: isSp() })
  }

  getDriverNameInitPage = (isAcceptPolicyDriverName, driver, booking) => {
    // isAcceptPolicyDriverName = true: when user has driver name and after they changed value driver name
    // driver?.name = false: when user first checkin, it is empty and after that have value if they change info
    if ((!driver?.name || isAcceptPolicyDriverName) && booking?.driverName) {
      return booking?.driverName
    }
    return driver?.name
  }

  onChangeText = (e, key) => {
    const { value } = e.target

    let newValue = value

    if (key === 'vehicleNumber') {
      newValue = newValue.replace(/[^0-9]/g, '')
    }

    this.props.updateBooking({ [key]: newValue })
  }

  onClickVehicleNumber = () => {
    const { isOpenNumericKeypad } = this.state
    this.setState({ isOpenNumericKeypad: !isOpenNumericKeypad })
  }

  onClickEnterVehicleNumber = () => {
    const {
      booking: { vehicleNumber },
    } = this.props
    this.props.updateBooking({ vehicleNumber: vehicleNumber.padStart(4, '0') })
    this.setState({ isOpenNumericKeypad: false })
  }

  onChangeSelectVehicleCategory = (e) => {
    const { value } = e.target
    this.props.updateBooking({ vehicleCategory: value })
  }

  handleChangeDriverCompany = (option) => {
    const { value, label } = option || { value: '', label: '' }

    // 入力の場合
    if (value === label || !value) {
      this.props.updateBooking({ driverCompanyId: '', driverCompanyName: value })
      return
    }

    // 選択の場合
    this.props.updateBooking({ driverCompanyId: value, driverCompanyName: label })
  }

  handleBlurDriverCompany = (e) => {
    const { value } = e.target

    if (!value) {
      // 選択の場合
      return
    }

    // 入力の場合
    this.props.updateBooking({ driverCompanyName: value })
  }

  onClickNumber = (value) => {
    const {
      booking: { vehicleNumber },
    } = this.props

    if (vehicleNumber.length === VEHICLE_NUMBER_LENGTH) return

    this.props.updateBooking({ vehicleNumber: `${vehicleNumber}${value}` })
  }

  onClickBackSpace = () => {
    const {
      booking: { vehicleNumber },
    } = this.props

    if (!vehicleNumber) return

    this.props.updateBooking({
      vehicleNumber: vehicleNumber.substring(0, vehicleNumber.length - 1),
    })
  }

  onFocusInput = (e) => {
    const { isAcceptPolicyDriverName } = this.props
    const { hasDriverName } = this.state
    if (hasDriverName && !isAcceptPolicyDriverName) {
      this.showConfirmModal()
      e.target.blur()
    }
  }

  onHandleConfirm = async () => {
    const { startLoading, openError, stopLoading } = this.props
    try {
      startLoading()
      const resp = await requestGet('/policies/newest', {})
      this.setState({ policyData: camelizeKeys(resp?.data?.display_policy_version) })
      this.showPolicyModal()
    } catch (error) {
      const { errorCodes, status } = getStatusCodesAndErrorCode(error)
      openError(error.message, true, errorCodes, status)
    } finally {
      stopLoading()
      this.closeConfirmModal()
    }
  }

  onHandleCancel = () => {
    this.closeConfirmModal()
  }

  onHandleAcceptPolicyModal = async () => {
    const { updateIsAcceptPolicy, updateBooking, driver, stopLoading, startLoading } = this.props
    const { policyData } = this.state
    try {
      startLoading()
      await requestPatch('/tablets/update_policy_checked', {
        phoneNumber: driver?.driverPhone,
        policyId: policyData?.id,
      })
      updateIsAcceptPolicy(true)
      updateBooking({ driverName: '' })
      const driverNameInput = document.getElementById(DRIVER_NAME_ID)
      if (driverNameInput) driverNameInput.focus()
    } catch (error) {
      const { errorCodes, status } = getStatusCodesAndErrorCode(error)
      this.props.openError(error.message, true, errorCodes, status)
    } finally {
      stopLoading()
      this.closePolicyModal()
    }
  }

  onHandleCancelPolicyModal = () => {
    this.closePolicyModal()
  }

  render() {
    const {
      match,
      vehicleCategories,
      booking,
      companies,
      driver,
      driverConfirmations,
      history,
      isAcceptPolicyDriverName,
    } = this.props
    const {
      params: { warehouseId, tenantId },
    } = match
    const { isOpenNumericKeypad, isOpenModalConfirm, isOpenPolicyModal, policyData } = this.state

    const vehicleCategoryOptions = vehicleCategories
      .filter(
        (option) =>
          (booking.vehicleCategory && booking.vehicleCategory == option.parameterId) ||
          option.displayFlag
      )
      .map((vehicleCategory) => ({
        value: vehicleCategory.parameterId,
        label: vehicleCategory.parameterName,
      }))
    const companyOptions = companies.map((company) => ({
      value: company.id,
      label: company.attributes.companyName,
    }))

    const isFreePlan = !driver.tenant.canBerthBook

    if (this.state.isSp) {
      return (
        <div style={{ backgroundColor: theme.graySoft6, minHeight: '100vh', fontSize: 18 }}>
          <Header driver={driver} isSp generalReceptionName={driver.tenant?.generalReceptionName} />
          
          <div className="p-3">
            <div className="mb-3">
              <StartFromBeginningButton
                onClick={() => history.push(`/receipt-booking/${warehouseId}/${tenantId}`)}
              />
            </div>

            <SpFrame title="ドライバー情報を入力">
              <div className="d-flex flex-column justify-content-around align-items-center" style={{ height: '314px' }}>
                <div style={{ width: 286, height: 70 }}>
                  <div className="d-flex align-items-center mb-2" data-dg-id="sp-entry-driver-info-page-label-driver-company-name" style={{ fontSize: 11 }}>
                    <RequiredTextSp data-dg-id="sp-entry-driver-info-page-required-driver-company-name">必須</RequiredTextSp>
                    運送会社名
                  </div>
                  <div data-dg-id="sp-entry-driver-info-page-input-driver-company-name">
                    <CreatableSelect2
                      isClearable
                      isInputDisplay
                      options={companyOptions}
                      value={{ value: booking.driverCompanyId, label: booking.driverCompanyName }}
                      onChange={this.handleChangeDriverCompany}
                      onBlur={this.handleBlurDriverCompany}
                      height="45px"
                      fontSize="14px"
                    />
                  </div>
                </div>

                <div style={{ width: 286, height: 70 }}>
                    <div className="d-flex align-items-center mb-2" data-dg-id="sp-entry-driver-info-page-label-driver-name" style={{ fontSize: 11 }}>
                      <RequiredTextSp data-dg-id="sp-entry-driver-info-page-required-driver-name">必須</RequiredTextSp>
                      氏名フルネーム
                  </div>
                  <Input
                    id={DRIVER_NAME_ID}
                    type="text"
                    value={booking.driverName}
                    placeholder={'例：山田　太郎'}
                    maxLength={50}
                    className="w-100"
                    style={{ height: 45, fontSize: 14 }}
                    onChange={(e) => {
                      this.onChangeText(e, 'driverName')
                    }}
                    onFocus={this.onFocusInput}
                    data-dg-id="sp-entry-driver-info-page-input-driver-name"
                  />
                </div>

                <div className="d-flex" style={{ width: 286, height: 70 }}>
                    <div style={{ width: 143 }} className="mr-2">
                      <div className="d-flex align-items-center mb-2" data-dg-id="sp-entry-driver-info-page-label-vehicle-number" style={{ fontSize: 11 }}>
                        <RequiredTextSp data-dg-id="sp-entry-driver-info-page-required-vehicle-number">必須</RequiredTextSp>
                        車番
                      </div>
                      <Input
                        type="text"
                        value={
                          booking.vehicleNumber
                            ? `${booking.vehicleNumber.substr(0, 2)}-${booking.vehicleNumber.substr(
                                2,
                                2
                              )}`
                            : ''
                        }
                        maxLength={VEHICLE_NUMBER_LENGTH}
                        onClick={this.onClickVehicleNumber}
                        onChange={_.noop}
                        className="w-100"
                        style={{ height: 45, fontSize: 14 }}
                        data-dg-id="sp-entry-driver-info-page-input-vehicle-number"
                      />
                    </div>
                    <div style={{ width: 143 }}>
                      <div className="d-flex align-items-center mb-2" data-dg-id="sp-entry-driver-info-page-label-vehicle-category" style={{ fontSize: 11 }}>
                        <RequiredTextSp data-dg-id="sp-entry-driver-info-page-required-vehicle-category">必須</RequiredTextSp>
                        車両形態
                      </div>
                      <SelectBase
                        className="w-100 bg-white px-2"
                        style={{
                          height: 45,
                          borderRadius: 4,
                          fontSize: 14,
                          border: `1px solid ${theme.grayMedium3}`,
                          color: theme.pureBlack
                        }}
                        value={booking.vehicleCategory}
                        onChange={this.onChangeSelectVehicleCategory}
                        data-dg-id="sp-entry-driver-info-page-input-vehicle-category"
                      >
                        {[EMPTY_OPTION].concat(vehicleCategoryOptions).map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </SelectBase>
                    </div>
                </div>
              </div>
            </SpFrame>
          </div>

          <div className="mt-4">
            <SpFooter
              onBackClick={
                isFreePlan
                  ? undefined
                  : () => history.push(`/receipt-booking/entry-bookings/${warehouseId}/${tenantId}`)
              }
              onNextClick={
                !booking.driverCompanyName?.trim() ||
                !booking.driverName?.trim() ||
                !booking.vehicleNumber ||
                !booking.vehicleCategory 
                ? undefined
                : () => history.push(`/receipt-booking/entry-load/${warehouseId}/${tenantId}`)
              }
              backButtonDgId="sp-entry-driver-info-page-back-button"
              nextButtonDgId={
                !booking.driverCompanyName?.trim() ||
                !booking.driverName?.trim() ||
                !booking.vehicleNumber ||
                !booking.vehicleCategory
                ? "sp-entry-driver-info-page-next-button-disabled"
                : "sp-entry-driver-info-page-next-button"
              }
            />
          </div>

          <Modal isOpen={isOpenNumericKeypad} style={{ width:358, padding: 12 }}>
            <ModalBody
              style={{
                overflow: 'auto',
              }}
            >
              <div className="p-3 d-flex flex-column mb-1">
                <div className="mb-3">
                  <PrevButton onClick={this.onClickVehicleNumber} />
                </div>
                <div className="text-center" style={{ fontSize: "20px" }}>
                  <span>車番を入力</span>
                </div>
              </div>
              <div className="text-center mb-3">
                <VehicleNumberInputSp
                  type="text"
                  value={booking.vehicleNumber}
                  maxLength={VEHICLE_NUMBER_LENGTH}
                  onChange={(e) => {
                    this.onChangeText(e, 'vehicleNumber')
                  }}
                />
              </div>
              <NumericKeypad
                value={booking.vehicleNumber}
                canClickEnter={booking.vehicleNumber && booking.vehicleNumber.length > 0}
                onClick={this.onClickNumber}
                onClickBackSpace={this.onClickBackSpace}
                onClickEnter={this.onClickEnterVehicleNumber}
                isSp
              />
            </ModalBody>
          </Modal>

          <ConfirmDriverNameModal
            isOpen={isOpenModalConfirm}
            title="ドライバー氏名を変更しますか？<br/>※ 利用規約に同意が必要です。"
            textClose="いいえ"
            textOk="はい"
            handleCancel={this.onHandleCancel}
            handleConfirm={this.onHandleConfirm}
          />

          <PolicyModal
            isOpen={isOpenPolicyModal}
            policyData={policyData}
            onAccept={this.onHandleAcceptPolicyModal}
            onCancel={this.onHandleCancelPolicyModal}
            isSp={this.state.isSp}
          />
        </div>
      )
    }

    return (
      <div style={{ backgroundColor: '#EDEDED', height: '100vh', fontSize: 18 }}>
        <Header driver={driver} />

        <div className="p-3">
          <div className="bg-white mb-3 p-3" style={{ borderRadius: 12 }}>
            <div className="text-center mb-3">
              <div className="text-size32 font-weight-bold">ドライバー情報を入力</div>
              <div>以下の情報を入力してください</div>
            </div>

            <div className="d-flex mx-auto mb-3" style={{ width: 550 }}>
              <CreatableSelectWrapper className="mr-3">
                <div className="d-flex align-items-center" data-dg-id="entry-driver-info-page-label-driver-company-name">
                  <RequiredText data-dg-id="entry-driver-info-page-required-driver-company-name">必須</RequiredText>
                  運送会社名
                </div>
                <div data-dg-id="entry-driver-info-page-input-driver-company-name">
                  <CreatableSelect2
                    isClearable
                    isInputDisplay
                    options={companyOptions}
                    value={{ value: booking.driverCompanyId, label: booking.driverCompanyName }}
                    onChange={this.handleChangeDriverCompany}
                    onBlur={this.handleBlurDriverCompany}
                    height="52px"
                    fontSize="24px"
                  />
                </div>
              </CreatableSelectWrapper>
              <div style={{ width: 260 }}>
                <div className="d-flex align-items-center" data-dg-id="entry-driver-info-page-label-vehicle-number">
                  <RequiredText data-dg-id="entry-driver-info-page-required-vehicle-number">必須</RequiredText>
                  車番
                </div>
                <Input
                  type="text"
                  value={
                    booking.vehicleNumber
                      ? `${booking.vehicleNumber.substr(0, 2)}-${booking.vehicleNumber.substr(
                          2,
                          2
                        )}`
                      : ''
                  }
                  maxLength={VEHICLE_NUMBER_LENGTH}
                  onClick={this.onClickVehicleNumber}
                  onChange={_.noop}
                  className="w-100 text-size24"
                  style={{ height: 52 }}
                  data-dg-id="entry-driver-info-page-input-vehicle-number"
                />
              </div>
            </div>

            <div className="d-flex mx-auto mb-3" style={{ width: 550 }}>
              <div style={{ width: 260 }} className="mr-3">
                <div className="d-flex align-items-center" data-dg-id="entry-driver-info-page-label-driver-name">
                  <RequiredText data-dg-id="entry-driver-info-page-required-driver-name">必須</RequiredText>
                  氏名フルネーム
                </div>
                <Input
                  id={DRIVER_NAME_ID}
                  type="text"
                  value={booking.driverName}
                  placeholder={'例：山田　太郎'}
                  maxLength={50}
                  className="w-100 text-size24"
                  style={{ height: 52 }}
                  onChange={(e) => {
                    this.onChangeText(e, 'driverName')
                  }}
                  onFocus={this.onFocusInput}
                  data-dg-id="entry-driver-info-page-input-driver-name"
                />
              </div>
              <div style={{ width: 260 }}>
                <div className="d-flex align-items-center" data-dg-id="entry-driver-info-page-label-vehicle-category">
                  <RequiredText data-dg-id="entry-driver-info-page-required-vehicle-category">必須</RequiredText>
                  車両形態
                </div>
                <SelectBase
                  className="w-100 bg-white px-2"
                  style={{
                    height: 52,
                    borderRadius: 4,
                    fontSize: 24,
                    border: '1px solid #CCC',
                    color: '#000',
                  }}
                  value={booking.vehicleCategory}
                  onChange={this.onChangeSelectVehicleCategory}
                  data-dg-id="entry-driver-info-page-input-vehicle-category"
                >
                  {[EMPTY_OPTION].concat(vehicleCategoryOptions).map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </SelectBase>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-between">
            <div style={{ width: '33%' }}>
              <PrevStartButton 
                to={`/receipt-booking/${warehouseId}/${tenantId}`} 
                data-dg-id="entry-driver-info-page-prev-start-button"
              />
            </div>
            <div className="text-center" style={{ width: '34%' }}>
              <PageNumber
                page="entry-driver-info"
                existsDriverConfirmations={Boolean(driverConfirmations.length)}
                isFreePlan={isFreePlan}
              />
            </div>
            <div className="text-right" style={{ width: '33%' }}>
              {!isFreePlan && (
                <Button
                  outline
                  color="primary"
                  className="mr-3 rounded-pill bg-white px-4 text-primary"
                  onClick={() =>
                    history.push(`/receipt-booking/entry-bookings/${warehouseId}/${tenantId}`)
                  }
                  data-dg-id="entry-driver-info-page-back-button-next"
                >
                  もどる
                </Button>
              )}
              <Button
                color="primary"
                className="rounded-pill px-4"
                disabled={
                  !booking.driverCompanyName?.trim() ||
                  !booking.driverName?.trim() ||
                  !booking.vehicleNumber ||
                  !booking.vehicleCategory
                }
                onClick={() =>
                  history.push(`/receipt-booking/entry-load/${warehouseId}/${tenantId}`)
                }
                data-dg-id={
                  !booking.driverCompanyName?.trim() ||
                  !booking.driverName?.trim() ||
                  !booking.vehicleNumber ||
                  !booking.vehicleCategory
                  ? "entry-driver-info-page-next-button-disabled" 
                  : "entry-driver-info-page-next-button"
                }
              >
                次へ
              </Button>
            </div>
          </div>
        </div>

        <Modal isOpen={isOpenNumericKeypad} size="lg" style={{ maxWidth: 664 + 32 }}>
          <ModalBody
            style={{
              overflow: 'auto',
            }}
          >
            <div className="p-3 d-flex justify-content-between align-items-center mb-1">
              <div style={{ width: '33%' }}>
                <PrevButton onClick={this.onClickVehicleNumber} />
              </div>
              <div className="text-center text-size24" style={{ width: '34%' }}>
                <span>車番を入力</span>
              </div>
              <div style={{ width: '33%' }} />
            </div>
            <div className="text-center mb-3">
              <VehicleNumberInput
                type="text"
                value={booking.vehicleNumber}
                maxLength={VEHICLE_NUMBER_LENGTH}
                onChange={(e) => {
                  this.onChangeText(e, 'vehicleNumber')
                }}
              />
            </div>
            <NumericKeypad
              value={booking.vehicleNumber}
              canClickEnter={booking.vehicleNumber && booking.vehicleNumber.length > 0}
              onClick={this.onClickNumber}
              onClickBackSpace={this.onClickBackSpace}
              onClickEnter={this.onClickEnterVehicleNumber}
            />
          </ModalBody>
        </Modal>

        <ConfirmDriverNameModal
          isOpen={isOpenModalConfirm}
          title="ドライバー氏名を変更しますか？<br/>※ 利用規約に同意が必要です。"
          textClose="いいえ"
          textOk="はい"
          handleCancel={this.onHandleCancel}
          handleConfirm={this.onHandleConfirm}
        />

        <PolicyModal
          isOpen={isOpenPolicyModal}
          policyData={policyData}
          onAccept={this.onHandleAcceptPolicyModal}
          onCancel={this.onHandleCancelPolicyModal}
        />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const reception = state.get('reception')
  return {
    driver: reception.driver,
    booking: reception.booking,
    companies: reception.companies,
    recentBooking: reception.recentBooking,
    vehicleCategories: reception.master.vehicleCategories,
    driverConfirmations: reception.driverConfirmations,
    returnEntryPage: reception.returnEntryPage,
    isAcceptPolicyDriverName: reception.isAcceptPolicyDriverName,
  }
}

const mapDispatchToProps = {
  fetchAnything,
  startLoading,
  stopLoading,
  openError,
  updateBooking,
  fetchSuccess,
  updateIsAcceptPolicy,
}

export default connect(mapStateToProps, mapDispatchToProps)(EntryDriverInfoPage)
